import React from "react";
import { m as motion } from "../../shared/components/Motion";

const ContactCard = ({ iconClass, title, data, link, onEdit, isAdmin }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 50, damping: 20 },
    },
  };

  return (
    <motion.div
      className="contact__card"
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      style={{ position: "relative" }}
    >
      {isAdmin && onEdit && (
        <motion.button
          whileHover={{ scale: 1.15 }}
          whileTap={{ scale: 0.9 }}
          onClick={onEdit}
          style={{
            position: "absolute",
            top: "0.5rem",
            right: "0.5rem",
            background: "var(--title-color)",
            color: "var(--body-color)",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          title="Edit contact"
        >
          <i className="bx bx-edit-alt" style={{ fontSize: "14px" }}></i>
        </motion.button>
      )}
      <i className={iconClass}></i>
      <h3 className="contact__card-title">{title}</h3>
      <span className="contact__card-data">{data}</span>
      <a
        rel="noopener noreferrer"
        href={link}
        target="_blank"
        className="contact__button"
      >
        Write me
      </a>
      <i className="bx bx-right-arrow-alt contact__button-icon"></i>
    </motion.div>
  );
};

export default ContactCard;
